import React, { Component } from 'react';
import SelectField from '../../../forms/SelectField';

class PerformanceFilters extends Component {
    _filtersRef = React.createRef();

    _setFilterArtists = f => this.props.setFilter('artists', f);
    _setFilterStages = f => this.props.setFilter('stages', f);
    _setCategoryFilter = categoryId => selectedLabels => {
        this.props.setCategoryFilter(categoryId, selectedLabels);
    };

    componentDidMount() {
        this._updateFiltersHeightCssVar();
        if (typeof ResizeObserver !== 'undefined') {
            this._resizeObserver = new ResizeObserver(this._updateFiltersHeightCssVar);
            this._resizeObserver.observe(this._filtersRef.current);
        } else {
            window.addEventListener('resize', this._updateFiltersHeightCssVar);
        }
    }

    componentWillUnmount() {
        if (this._resizeObserver) {
            this._resizeObserver.disconnect();
        } else {
            window.removeEventListener('resize', this._updateFiltersHeightCssVar);
        }
        document.documentElement.style.setProperty('--ckp-timetable-filters-height', '0px');
    }

    _updateFiltersHeightCssVar = () => {
        const el = this._filtersRef.current;
        if (!el) return;
        document.documentElement.style.setProperty('--ckp-timetable-filters-height', `${el.offsetHeight}px`);
    };

    render() {
        const { artistOptions, stageOptions, visibleCategories, categoryFilters } = this.props;

        return (
            <div className="ckp-timetable-list-filters" ref={this._filtersRef}>
                <div className="ckp-grid-row is-wrap">
                    <div className="ckp-grid-column no-margin-first">
                        <SelectField
                            onChange={this._setFilterArtists}
                            items={artistOptions}
                            label="Artist"
                            multiple={true}
                            value={this.props.artistsFilters}
                        />
                    </div>
                    <div className="ckp-grid-column">
                        <SelectField
                            onChange={this._setFilterStages}
                            items={stageOptions}
                            label="Stage"
                            multiple={true}
                            value={this.props.stagesFilters}
                        />
                    </div>
                    {visibleCategories.map(category => (
                        <div className="ckp-grid-column" key={category.id}>
                            <SelectField
                                onChange={this._setCategoryFilter(category.id)}
                                items={category.options}
                                label={category.label}
                                multiple={true}
                                value={categoryFilters[category.id] || []}
                            />
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default PerformanceFilters;
